import { createUseMutation } from 'api/common/createUseMutation'
import { patchVisibilityPreferences } from 'api/fetchers/visibility/patchVisibilityPreferences'
import { queryClient } from 'app/Root'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useVisibilityPreferencesPatch = createUseMutation({
  fetcher: patchVisibilityPreferences,
  onSettled: async () => {
    await queryClient.invalidateQueries({ queryKey: [ApiQueryKeys.ME] })
    await queryClient.invalidateQueries({ queryKey: [ApiQueryKeys.VISIBILITY_PREFERENCES] })
    await queryClient.invalidateQueries({ queryKey: [ApiQueryKeys.PRACTITIONERS] })
  },
})
